import React, {useState} from 'react';
import './Music.css';
import TrackItem from "../../components/TrackItem/TrackItem";
import nineties from '../../assets/audio/90s.mp3';
import atlantis from '../../assets/audio/atlantis.mp3';
import faith from '../../assets/audio/faith.mp3';
import fatum from '../../assets/audio/fatum.mp3';
import filosofia from '../../assets/audio/filosofia.mp3';
import friend from '../../assets/audio/friend.mp3';
import gaspar from '../../assets/audio/Gaspar.mp3';
import he from '../../assets/audio/he.mp3';
import life from '../../assets/audio/life.mp3';
import mayakovsky from '../../assets/audio/mayakovsky.mp3';
import mudrie from '../../assets/audio/mudrie.mp3';
import no_time from '../../assets/audio/no_time.mp3';
import roads from '../../assets/audio/roads.mp3';
import silence from '../../assets/audio/silence.mp3';
import silver_thread from '../../assets/audio/silver_thread.mp3';
import stress from '../../assets/audio/stress.mp3';
import rethinking from '../../assets/audio/rethinking.mp3';
import loneliness from '../../assets/audio/loneliness.mp3';
import rubicon from '../../assets/audio/beyond_the_rubicon_of_love.mp3';
import lines_about_love from '../../assets/audio/lines_about_love.mp3';
import lastLetter from '../../assets/audio/lastLetter.mp3';
import forLouise from '../../assets/audio/forLouise.mp3';
import myLove from '../../assets/audio/myLove.mp3';
import naytiSebya from '../../assets/audio/naytiSebya.mp3';
import october from '../../assets/audio/october.mp3';
import detstvo_remaster from '../../assets/audio/90s_remastered2026.mp3';
import faith_remake from '../../assets/audio/faith_remake2026.mp3';
import filosophia_remaster from '../../assets/audio/filosophia_remaster2026.mp3';
import findMyself_remastered from '../../assets/audio/findMyself_remastered2026.mp3';
import goldEraOfBasketball from '../../assets/audio/goldEraOfBasketball.mp3';
import lastLetter_full from '../../assets/audio/lastLetter_full_ver2026.mp3';
import life_remake from '../../assets/audio/life_remake2026.mp3';
import loveAbout_remake from '../../assets/audio/loveAbout_remake2026.mp3';
import noTime_remake from '../../assets/audio/noTime_remake2026.mp3';
import october_remake from '../../assets/audio/october_remake2026.mp3';
import polygon_remake from '../../assets/audio/polygon_remake2026.mp3';
import rethinking_remake from '../../assets/audio/rethinking_remake2026.mp3';
import roads_remastered from '../../assets/audio/roads_remastered2026.mp3';
import rubicon_remastered from '../../assets/audio/rubicon_remastered2026.mp3';
import silverThread_remastered from '../../assets/audio/silverThread_remastered2026.mp3';
import stressTech_remake from '../../assets/audio/stressTech_remake2026.mp3';
import blood from '../../assets/audio/blood.mp3';
import bulgaria_pic from '../../assets/img/bulgaria.jpg';
import everyone_album_pic from '../../assets/img/everyone_album.jpg';
import fatum_pic from '../../assets/img/fatum.jpg';
import mudrie_pic from '../../assets/img/mudrie.jpg';
import silence_pic from '../../assets/img/silence.jpg';
import loveAbout_pic from '../../assets/img/love_about.jpg';
import unreleased from '../../assets/img/unreleased.jpg';
import rethinking_pic from '../../assets/img/rethinking.jpg';
import lastLetter_pic from '../../assets/img/lastLetter.jpg';
import detstvo_pic from '../../assets/img/90s.jpg';
import blood_pic from '../../assets/img/blood.jpg';
import faith_pic from '../../assets/img/faith.jpg';
import filosophia_pic from '../../assets/img/filosophia.jpg';
import findMyself_pic from '../../assets/img/findMyself.jpg';
import GEoB_pic from '../../assets/img/GEoB.jpg';
import lastLetter_full_pic from '../../assets/img/lastLetter_full.jpg';
import life_pic from '../../assets/img/life.jpg';
import loveAboutSingle_pic from '../../assets/img/loveAbout.jpg';
import noTime_pic from '../../assets/img/noTime.jpg';
import october_pic from '../../assets/img/october.jpg';
import polygon_pic from '../../assets/img/polygon.jpg';
import rethinking_cover_pic from '../../assets/img/rethinking_cover.jpg';
import roads_pic from '../../assets/img/roads.jpg';
import rubicon_pic from '../../assets/img/rubicon.jpg';
import silverThread_pic from '../../assets/img/silverThread.jpg';
import stress_pic from '../../assets/img/stress.jpg';

const Music = () => {
    const tracks = [
        {
            id: 42, name: "Золотая эпоха баскетбола", audio: goldEraOfBasketball, picture: GEoB_pic, year: 2026
        },
        {
            id: 41, name: "Переосмысление Remake", audio: rethinking_remake, picture: rethinking_cover_pic, year: 2026
        },
        {
            id: 40, name: "Кровь", audio: blood, picture: blood_pic, year: 2026
        },
        {
            id: 39, name: "Строки о любви Remake", audio: loveAbout_remake, picture: loveAboutSingle_pic, year: 2026
        },
        {
            id: 38, name: "За рубикон любви Remastered", audio: rubicon_remastered, picture: rubicon_pic, year: 2026
        },
        {
            id: 37, name: "Не существет времени Remake", audio: noTime_remake, picture: noTime_pic, year: 2026
        },
        {
            id: 36, name: "Жизнь Remake", audio: life_remake, picture: life_pic, year: 2026
        },
        {
            id: 35, name: "По серебряной нити Remastered", audio: silverThread_remastered, picture: silverThread_pic, year: 2026
        },
        {
            id: 34, name: "Детство в 90-е Remastered", audio: detstvo_remaster, picture: detstvo_pic, year: 2026
        },
        {
            id: 33, name: "Вера Remake", audio: faith_remake, picture: faith_pic, year: 2026
        },
        {
            id: 32, name: "Философия Remastered", audio: filosophia_remaster, picture: filosophia_pic, year: 2026
        },
        {
            id: 31, name: "Найти себя Remastered", audio: findMyself_remastered, picture: findMyself_pic, year: 2026
        },
        {
            id: 30, name: "Дороги Remake", audio: roads_remastered, picture: roads_pic, year: 2026
        },
        {
            id: 29, name: "Октябрь Remake", audio: october_remake, picture: october_pic, year: 2026
        },
        {
            id: 28, name: "Полигон для битвы Remake", audio: polygon_remake, picture: polygon_pic, year: 2026
        },
        {
            id: 27, name: "Технология стресса Remake", audio: stressTech_remake, picture: stress_pic, year: 2026
        },
        {
            id: 26, name: "Последнее письмо (полная версия)", audio: lastLetter_full, picture: lastLetter_full_pic, year: 2026
        },
        {
            id: 25, name: "Последнее письмо", audio: lastLetter, picture: lastLetter_pic, year: 2025
        },
        {
            id: 24, name: "Переосмысление", audio: rethinking, picture: rethinking_pic, year: 2024
        },
        {
            id: 23, name: "Чему учили мудрые", audio: mudrie, picture: mudrie_pic, year: 2019
        },
        {
            id: 22, name: "Маяковский в Болгарии", audio: mayakovsky, picture: bulgaria_pic, year: 2019
        },
        {
            id: 21, name: "Фатум", audio: fatum, picture: fatum_pic, year: 2018
        },
        {
            id: 20, name: "Молчание", audio: silence, picture: silence_pic, year: 2015
        },
        {
            id: 19, name: "Найти себя", audio: naytiSebya, picture: unreleased, year: 2008
        },
        {
            id: 18, name: "Октябрь", audio: october, picture: unreleased, year: 2008
        },
        {
            id: 17, name: "Строки о любви (версия)", audio: lines_about_love, picture: loveAbout_pic, year: 2008
        },
        {
            id: 16, name: "Одиночество", audio: loneliness, picture: loveAbout_pic, year: 2008
        },
        {
            id: 15, name: "За рубикон любви", audio: rubicon, picture: loveAbout_pic, year: 2008
        },
        {
            id: 14, name: "Моя любовь", audio: myLove, picture: unreleased, year: 2008
        },
        {
            id: 13, name: "Луизе", audio: forLouise, picture: loveAbout_pic, year: 2008
        },
        {
            id: 12, name: "Атланитида", audio: atlantis, picture: loveAbout_pic, year: 2008
        },
        {
            id: 11, name: "Дороги", audio: roads, picture: unreleased, year: 2008
        },
        {
            id: 10, name: "Технологии стресса", audio: stress, picture: unreleased, year: 2008
        },
        {
            id: 9, name: "Гаспар Рикке", audio: gaspar, picture: everyone_album_pic, year: 2007
        },
        {
            id: 8, name: "Философия", audio: filosofia, picture: everyone_album_pic, year: 2007
        },
        {
            id: 7, name: "Вера", audio: faith, picture: everyone_album_pic, year: 2007
        },
        {
            id: 6, name: "Он", audio: he, picture: everyone_album_pic, year: 2007
        },
        {
            id: 5, name: "Не существует времени", audio: no_time, picture: everyone_album_pic, year: 2007
        },
        {
            id: 4, name: "Жизнь", audio: life, picture: everyone_album_pic, year: 2007
        },
        {
            id: 3, name: "По серебряной нити", audio: silver_thread, picture: everyone_album_pic, year: 2007
        },
        {
            id: 2, name: "Друг", audio: friend, picture: everyone_album_pic, year: 2007
        },
        {
            id: 1, name: "Детство в 90-е", audio: nineties, picture: everyone_album_pic, year: 2007
        },
    ]

    const [active, setActive] = useState(false);

    return (
        <div className="container">
                    <h1 className="music__h1">Трек лист</h1>
                    {
                        tracks.map(item => <TrackItem
                            key={item.id}
                            item={item}
                            active={active}
                            setActive={setActive}
                        />
                        )
                    }
        </div>
    );
};

export default Music;